export const environment = {
    production: false,
    AWS_ACCESS_KEY_ID: "AKIA5HJR2ZR5YIYGARGG",
    AWS_SECRET_ACCESS_KEY: "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",
    RASTER2TILES_BUCKET: 's3-globesensing-assets',
    AWS_REGION: "us-east-1"
  };
  
